// extracted by mini-css-extract-plugin
export var allNewsButton = "index-module--allNewsButton--3666f";
export var carousel = "index-module--carousel--25820";
export var informationBanner = "index-module--informationBanner--3c6da";
export var mainBlocks = "index-module--mainBlocks--2722f";